'use strict';

import React, { Component } from 'react';
import CloseChat from 'components/CloseChat';
import Upload from 'components/Upload';
import SendTranscript from 'components/SendTranscript';

class ChatActions extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="chat-actions">
				<CloseChat onEndChat={this.props.onEndChat}/>
				<Upload onFileUpload={this.props.onFileUpload}/>
				<SendTranscript onSendTranscript={this.props.onSendTranscript}/>
			</div>
		);
	}
}

ChatActions.displayName = 'ChatActions';
ChatActions.propTypes = {
	onEndChat: React.PropTypes.func,
	onSendTranscript: React.PropTypes.func,
	onFileUpload: React.PropTypes.func
};
export default ChatActions;


// WEBPACK FOOTER //
// ./src/components/ChatActions.js